import type { Lang } from '@/i18n'

const strings = {
  de: {
    kicker: (techniques: number, categories: number, chains: number) =>
      `— CYBERSECURITY ATLAS · ${techniques} TECHNIKEN · ${categories} KATEGORIEN · ${chains} CHAINS —`,
    attackLabel: 'ATTACK · VERSTEHEN',
    attackText: 'Wie Angriffe ablaufen – Schritt für Schritt, ohne Exploit-Anleitungen.',
    defenseLabel: 'DEFENSE · SCHÜTZEN',
    defenseText: 'Schutzmaßnahmen, Erkennung und Härtung – priorisiert und praxisnah.',
    entries: 'EINTR.',
    featured: 'Featured',
    featuredHint: 'ZULETZT VERVOLLSTÄNDIGT',
    categories: 'Kategorien',
    hitTechnique: 'TECHNIK',
    hitChain: 'CHAIN',
    hitTool: 'TOOL',
    searchFooter: '↑↓ NAVIGIEREN · ↵ ÖFFNEN · ESC SCHLIESSEN',
    results: 'TREFFER',
    home: 'HOME',
    explore: 'ATLAS',
    status: 'STATUS',
    chains: 'ATTACK CHAINS',
    tools: 'TOOLS-DB',
    techniqueKicker: (category: string, subcategory: string, number: string) => `— ATTACK TECHNIQUE · ${number} ${category.toUpperCase()} · ${subcategory.toUpperCase()} —`,
    techniqueSubtitle: 'SCHUTZ UMGEHEN. ZUGRIFF ERLANGEN.',
  },
  en: {
    kicker: (techniques: number, categories: number, chains: number) =>
      `— CYBERSECURITY ATLAS · ${techniques} TECHNIQUES · ${categories} CATEGORIES · ${chains} CHAINS —`,
    attackLabel: 'ATTACK · UNDERSTAND',
    attackText: 'How attacks unfold – step by step, without exploit instructions.',
    defenseLabel: 'DEFENSE · PROTECT',
    defenseText: 'Countermeasures, detection and hardening – prioritised and practical.',
    entries: 'ENTRIES',
    featured: 'Featured',
    featuredHint: 'RECENTLY COMPLETED',
    categories: 'Categories',
    hitTechnique: 'TECHNIQUE',
    hitChain: 'CHAIN',
    hitTool: 'TOOL',
    searchFooter: '↑↓ NAVIGATE · ↵ OPEN · ESC CLOSE',
    results: 'RESULTS',
    home: 'HOME',
    explore: 'ATLAS',
    status: 'STATUS',
    chains: 'ATTACK CHAINS',
    tools: 'TOOLS-DB',
    techniqueKicker: (category: string, subcategory: string, number: string) => `— ATTACK TECHNIQUE · ${number} ${category.toUpperCase()} · ${subcategory.toUpperCase()} —`,
    techniqueSubtitle: 'BYPASS PROTECTION. GAIN ACCESS.',
  },
}

export function neonStrings(lang: Lang) {
  return strings[lang] || strings.de
}
